import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import ContentEditable from "react-contenteditable";
import styled from "styled-components";
import { List } from "../../../assets/icons";
import TextView from "../../TextView";
import UserImage from "../../UserImage";
import { transformEditorText } from "../../../utils/helpers";

// Styled Components
const Container = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  background-color: #ffffffe5;
  border-radius: 0px 0px 24px 24px;
  padding: 10px 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  z-index: 200;
  overflow: hidden;
  max-height: calc(100vh - 15vh - 3vw);
  max-height: calc(100svh - 18svh - 3vw);
  overflow: scroll;
`;

const Header = styled.div`
  cursor: pointer;
  display: grid;
  grid-template-columns: 1fr 80px;
  align-items: center;
  justify-content: space-between;
  height: 5vh;
  height: 7svh;
`;

const Description = styled.div`
  flex-direction: column;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  transition: display 1s ease-in-out;
  gap: 10px;
  padding-bottom: 10px;
  align-items: flex-start;
`;

const Row = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: center;
  margin: 0px 5px;
`;

const WheelDescription = ({ data, userProfile, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDescription = () => {
    setIsOpen(!isOpen);
  };

  const { wheel_name, description, sub_title } = data;
  const { first_name, last_name, profile_image } = userProfile;

  return (
    <Container isOpen={isOpen}>
      <Header>
        <TextView
          variant="subtitle"
          style={{ fontWeight: 700, WebkitLineClamp: 2 }}
        >
          <ContentEditable html={transformEditorText(wheel_name)} disabled />
        </TextView>
        <Row>
          {isOpen ? (
            <ExpandLessIcon onClick={toggleDescription} />
          ) : (
            <ExpandMoreIcon onClick={toggleDescription} />
          )}

          <List onClick={onClick} />
        </Row>
      </Header>
      <Description isOpen={isOpen}>
        <TextView variant="subtitle">
          <ContentEditable html={transformEditorText(sub_title)} disabled />
        </TextView>
        <ContentEditable html={transformEditorText(description)} disabled />
        <Row>
          <UserImage image={profile_image} />
          <TextView variant="subtitle">
            {first_name} {last_name}
          </TextView>
        </Row>
      </Description>
    </Container>
  );
};

export default WheelDescription;
